import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  return (
    <select
      value={i18n.language}
      onChange={(e) => changeLanguage(e.target.value)}
      className="bg-white/10 backdrop-blur-lg border border-white/20 text-white px-4 py-2 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      <option value="en" className="bg-gray-800">🇺🇸 English</option>
      <option value="es" className="bg-gray-800">🇲🇽 Español</option>
    </select>
  );
};

export default LanguageSelector;
